import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const SynchronizeSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default SynchronizeSVG;
